import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ActionCreator } from 'reducer/validation/validation';

const phoneMasks = {
  RU: { mask: '+7 (999) 999-99-99', value: 11 },
  TJ: { mask: '+999 9999 9-99-99', value: 12 },
  BY: { mask: '+375 99 999-99-99', value: 12 },
  KZ: { mask: '+7 (799) 999-99-99', value: 11 },
};

const resetPatterns = [
  '+7 ___) ___-__-__',
  '+99_ ____ _-__-__',
  '+7 (___) ___-__-__',
  '+375 __ ___-__-__',
  '+7 (7__) ___-__-__',
];

const countryCodeMap = {
  992: 'TJ',
  375: 'BY',
  79: 'RU',
  77: 'KZ',
};

export const useValidationPhone = (
  initState = '+',
  validateCountry = ['RU', 'TJ', 'BY', 'KZ'],
  dispatchName = 'setTelError'
) => {
  const [phone, setPhone] = useState(initState);
  const [cleanPhone, setCleanPhone] = useState('');
  const [isValidPhone, setValidPhone] = useState(!!initState);
  const [mask, setMask] = useState('');

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const updateMask = (phone) => {
    if (resetPatterns.includes(phone)) {
      setMask('');
      setPhone('+');
      return;
    }

    const sanitizedPhone = phone.replace(/\D/g, '');
    const countryCode = sanitizedPhone.startsWith('7')
      ? sanitizedPhone.substring(0, 2)
      : sanitizedPhone.substring(0, 3);

    const countryKey = countryCodeMap[countryCode];

    if (
      countryKey &&
      validateCountry.includes(countryKey) &&
      mask !== phoneMasks[countryKey]?.mask
    ) {
      setMask(phoneMasks[countryKey].mask);
    }
  };

  useEffect(() => {
    if (phone && phone !== '+') {
      updateMask(phone);
      setCleanPhone(phone.replace(/\D/g, ''));
    }
  }, [phone]);

  useEffect(() => {
    const currentCountry = validateCountry.find(
      (country) => mask === phoneMasks[country]?.mask
    );

    const isValid = cleanPhone.length === phoneMasks[currentCountry]?.value;

    setValidPhone(isValid);

    dispatch(
      ActionCreator[dispatchName](isValid ? '' : t('lk.relship.telError'))
    );
  }, [cleanPhone, mask, validateCountry, dispatch, t, dispatchName]);

  const handlePhoneChange = (newPhone) => {
    setPhone(newPhone || '+');
  };

  const handleFocus = (evt) => {
    evt.target.classList.remove('error-reg');
    dispatch(ActionCreator[dispatchName](''));
  };

  return [
    phone,
    isValidPhone,
    handlePhoneChange,
    handleFocus,
    setPhone,
    setValidPhone,
    mask,
    cleanPhone,
  ];
};
